










































import Vue from 'vue'
import { defaultPosterImage } from '@/helper/constants'

export default Vue.extend({
  props: {
    post: {
      type: Object,
      required: true
    },
    nextLesson: {
      type: Object
    }
  },
  data() {
    return {
      defaultPosterImage
    }
  },
  computed: {
    nextLessonContent(): string {
      return this?.nextLesson?.content || 'Awesome! Continue Pushing!'
    }
  }
})
